import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

const primaryColor = window.location.hostname === 'maia-test.acuminor.com' ? '#b5513f' : '#1976D2';

export default new Vuetify({
  theme: {
    dark: localStorage.getItem('darkMode') === 'true',
    themes: {
      light: {
        primary: primaryColor,
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
      },
      dark: {
        primary: primaryColor,
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
      },
    },
  },
});
